// Boston College's undergraduate majors (#2746). Read on 2026-10-01 from
// Boston College Undergraduate Admission's Majors and Minors page, which
// lists each division's majors (with the degree for Carroll, Connell and
// Lynch; the Morrissey College list names no degree, so `degree` is null
// there). Left out: minors, Carroll's Entrepreneurship co-concentration,
// and Messina College's two-year associate program. Global Public Health
// and the Common Good sits under Connell, where the page places it, with
// the page's note on how students enter it.
const majors = {
    "slug": "boston-college",
    "read": "2026-10-01",
    "intro": "Every undergraduate major on Boston College Admission's official Majors and Minors page, grouped by the school you apply to, with the degree where the page names one. Minors, co-concentrations and the associate degree at Messina College are left out.",
    "groups": [
        {
            "name": "Carroll School of Management",
            "source": {
                "label": "Boston College Undergraduate Admission, Majors and Minors",
                "url": "https://www.bc.edu/bc-web/admission/majors-minors.html"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Accounting for Finance and Consulting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "General Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management and Leadership",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Connell School of Nursing",
            "source": {
                "label": "Boston College Undergraduate Admission, Majors and Minors",
                "url": "https://www.bc.edu/bc-web/admission/majors-minors.html"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Global Public Health and the Common Good",
                    "degree": "B.A./B.S."
                }
            ],
            "note": "Global Public Health and the Common Good: you apply to the Morrissey College, then to the program in the spring of your first year, and move into the Connell School if accepted. Nursing applicants apply directly to the Connell School."
        },
        {
            "name": "Lynch School of Education and Human Development",
            "source": {
                "label": "Boston College Undergraduate Admission, Majors and Minors",
                "url": "https://www.bc.edu/bc-web/admission/majors-minors.html"
            },
            "majors": [
                {
                    "name": "American Heritages",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Psychology and Human Development",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics/Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Perspectives on Spanish America",
                    "degree": "B.A."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Transformative Educational Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Morrissey College of Arts and Sciences",
            "source": {
                "label": "Boston College Undergraduate Admission, Majors and Minors",
                "url": "https://www.bc.edu/bc-web/admission/majors-minors.html"
            },
            "majors": [
                {
                    "name": "African and African Diaspora Studies",
                    "degree": null
                },
                {
                    "name": "Applied Physics",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film Studies",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Geological Sciences",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Human-Centered Engineering",
                    "degree": null
                },
                {
                    "name": "Independent",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Islamic Civilization and Societies",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Slavic Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Theology",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
